export default "__VITE_ASSET__4VFTxxOD__"